import { useMemo } from 'react'
import { Column } from './types'


export function useColumnTitles(currency: string = '₽') {
  const columns = useMemo(() => {
    return {
      [Column.Status]: '№/Статус',
      [Column.Date]: 'Дата',
      [Column.Value]: `Сумма на\u00A0вывод, ${currency}`,
      [Column.Action]: 'Действие',
    }
  }, [currency])

  return columns
}
